import { messages } from 'helpers/validationMessages'
import * as yup from 'yup'
import { stepTwoArrayField } from 'feature/registration/heplers/validationHelpers'
import { createEmptyAddress } from 'feature/registration/heplers/addressHelpers'
import { RegistrationLkmData } from 'feature/registration/types'
import { EMAIL_REGEX } from '../../../constants/validation'

export const registrationLkmSchema = yup.object().shape({
  firstname: yup
    .string()
    .required(messages.required)
    .max(100, messages.maxLength(100))
    .test('notOnlySpaces', messages.required, value => value.trim() !== ''),
  lastname: yup
    .string()
    .required(messages.required)
    .max(100, messages.maxLength(100))
    .test('notOnlySpaces', messages.required, value => value.trim() !== ''),
  middlename: yup.string().max(100, messages.maxLength(100)),
  email: yup
    .string()
    .required('Email обязателен для заполнения')
    .matches(EMAIL_REGEX, 'Введите корректный email')
    .test(
      'no-com-domain',
      `В связи с новым законодательством, вы не можете зарегистрировать аккаунт на иностранный почтовый адрес
     (заканчивается на ".com"). Пожалуйста, воспользуйтесь другой почтой.`,
      value => {
        if (!value) return true

        return !value.toLowerCase().endsWith('.com')
      },
    ),
  personalAgree: yup
    .boolean()
    .test('personal-agree', '', value => value === true),
  productTypes: stepTwoArrayField(),
  serviceRegions: stepTwoArrayField(),
  companyName: yup
    .string()
    .max(100, messages.maxLength(100))
    .test(
      'notOnlySpaces',
      messages.required,
      value => !value || value.trim() !== '',
    ),
})

export const createRegistrationLkmDefaultValues = (): RegistrationLkmData => ({
  firstname: '',
  lastname: '',
  middlename: '',
  email: '',
  address: createEmptyAddress(),
  personalAgree: false,
  productTypes: [],
  serviceRegions: [],
  companyName: '',
})
